import { Link } from 'react-router-dom';

const INK    = '#0d0d0d';
const BLUE   = '#1755f4';
const MUTED  = '#888';
const BORDER = '#e8e8e8';

const css = `
*{box-sizing:border-box}
.lp-legal{font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;color:${INK};background:white;min-height:100vh}
.lp-legal a{text-decoration:none;color:inherit}
.lp-legal nav{position:sticky;top:0;z-index:100;background:rgba(255,255,255,0.97);backdrop-filter:blur(8px);border-bottom:1px solid ${BORDER};padding:0 48px;height:60px;display:flex;align-items:center;justify-content:space-between}
.lp-legal .logo{font-size:15px;font-weight:900;letter-spacing:2px;text-transform:uppercase;color:${INK}}
.lp-legal .logo span{color:${BLUE}}
.lp-legal footer{background:#0a0a0a;padding:32px 48px;display:flex;justify-content:space-between;align-items:center;font-size:11px;color:rgba(255,255,255,0.2);letter-spacing:0.5px}
`;

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '48px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
        <div style={{ width: '24px', height: '1px', background: INK }} />
        <span style={{ fontSize: '9px', fontWeight: 700, letterSpacing: '3px', textTransform: 'uppercase', color: INK }}>
          {title}
        </span>
      </div>
      <div style={{ fontSize: '14px', color: '#444', lineHeight: 1.9 }}>
        {children}
      </div>
    </div>
  );
}

function P({ children }) {
  return <p style={{ marginBottom: '12px' }}>{children}</p>;
}

function Li({ children }) {
  return (
    <li style={{ marginBottom: '8px', display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
      <span style={{ color: BLUE, fontWeight: 900, marginTop: '2px', flexShrink: 0 }}>—</span>
      <span>{children}</span>
    </li>
  );
}

export default function Datenschutz() {
  return (
    <div className="lp-legal">
      <style>{css}</style>

      <nav>
        <Link to="/" className="logo">IMMO<span>HQ</span></Link>
        <div style={{ display: 'flex', gap: '8px' }}>
          <Link to="/login" style={{ fontSize: '12px', fontWeight: 600, background: 'none', border: `1px solid ${BORDER}`, padding: '8px 16px', color: INK }}>
            Anmelden
          </Link>
          <Link to="/register" style={{ fontSize: '12px', fontWeight: 700, background: INK, border: 'none', padding: '9px 20px', color: 'white' }}>
            Kostenlos starten
          </Link>
        </div>
      </nav>

      <div style={{ maxWidth: '760px', margin: '0 auto', padding: '80px 48px' }}>

        {/* Page header */}
        <div style={{ marginBottom: '64px', borderBottom: `1px solid ${BORDER}`, paddingBottom: '48px' }}>
          <div style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '4px', textTransform: 'uppercase', color: MUTED, marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span style={{ width: '32px', height: '1px', background: MUTED, display: 'inline-block' }} />
            Rechtliches
          </div>
          <h1 style={{ fontSize: '64px', fontWeight: 900, letterSpacing: '-4px', lineHeight: 1, color: INK, margin: '0 0 16px' }}>
            Datenschutz
          </h1>
          <p style={{ fontSize: '14px', color: MUTED, lineHeight: 1.7, margin: 0 }}>
            Datenschutzerklärung gemäß DSGVO (EU) 2016/679 und BDSG. Stand: April 2025.
          </p>
        </div>

        <Section title="Verantwortlicher">
          <P><strong>Canel Sözer</strong></P>
          <P>Schuntertal 23<br />38108 Braunschweig<br />Deutschland</P>
          <P>E-Mail: <a href="mailto:info@immohq.eu" style={{ color: BLUE, fontWeight: 600 }}>info@immohq.eu</a></P>
        </Section>

        <Section title="Grundsätze der Datenverarbeitung">
          <P>
            Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, BDSG). In dieser Datenschutzerklärung informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer Website und unserer Softwareplattform ImmoHQ.
          </P>
        </Section>

        <Section title="Erhobene Daten und Zwecke">
          <P><strong>Bei der Registrierung und Nutzung erheben wir:</strong></P>
          <ul style={{ listStyle: 'none', padding: 0, marginBottom: '16px' }}>
            <Li>Vollständiger Name und E-Mail-Adresse (Kontoerstellung und Kommunikation)</Li>
            <Li>Firmenname / Unternehmensbezeichnung (Profildarstellung)</Li>
            <Li>Von Ihnen eingegebene Verwaltungsdaten: Objekte, Mieter, Verträge, Kosten, Kautionen, Dokumente</Li>
            <Li>Technische Daten: IP-Adresse, Browser-Typ, Zugriffszeiten (Sicherheit und Fehlerdiagnose)</Li>
          </ul>
          <P>
            Wir verarbeiten diese Daten ausschließlich zur Erbringung des ImmoHQ-Dienstes und zur Kommunikation mit Ihnen. Eine Weitergabe an Dritte zu Werbezwecken findet nicht statt.
          </P>
        </Section>

        <Section title="Rechtsgrundlagen der Verarbeitung">
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <Li><strong>Art. 6 Abs. 1 lit. b DSGVO</strong> – Vertragserfüllung: Verarbeitung zur Erbringung unseres Dienstes</Li>
            <Li><strong>Art. 6 Abs. 1 lit. a DSGVO</strong> – Einwilligung: z. B. E-Mail-Benachrichtigungen</Li>
            <Li><strong>Art. 6 Abs. 1 lit. f DSGVO</strong> – Berechtigte Interessen: Sicherheit, Missbrauchsprävention, Verbesserung des Dienstes</Li>
            <Li><strong>Art. 6 Abs. 1 lit. c DSGVO</strong> – Rechtliche Verpflichtung: Aufbewahrung steuerrelevanter Daten</Li>
          </ul>
        </Section>

        <Section title="Datenspeicherung und Hosting">
          <P>
            ImmoHQ nutzt die Infrastruktur von <strong>Supabase</strong> (Supabase Inc.) für Datenbankdienste und Authentifizierung. Die Daten werden auf Servern in der <strong>Europäischen Union</strong> gespeichert. Mit Supabase besteht ein Auftragsverarbeitungsvertrag (AVV) gemäß Art. 28 DSGVO.
          </P>
          <P>
            Ihre Daten werden für die Dauer Ihrer Nutzung des Dienstes gespeichert. Nach Kündigung werden Ihre Daten innerhalb von 30 Tagen unwiderruflich gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
          </P>
        </Section>

        <Section title="Cookies und Tracking">
          <P>
            ImmoHQ verwendet ausschließlich technisch notwendige Cookies für die Authentifizierung (Session-Management). Es werden keine Tracking-Cookies, Marketing-Cookies oder Analyse-Tools eingesetzt. Es findet keine Weitergabe von Daten an Werbenetzwerke statt.
          </P>
        </Section>

        <Section title="Ihre Rechte als betroffene Person">
          <P>Sie haben jederzeit folgende Rechte gegenüber uns:</P>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <Li><strong>Auskunft</strong> (Art. 15 DSGVO): Welche Daten wir über Sie gespeichert haben</Li>
            <Li><strong>Berichtigung</strong> (Art. 16 DSGVO): Korrektur unrichtiger Daten</Li>
            <Li><strong>Löschung</strong> (Art. 17 DSGVO): Löschung Ihrer Daten, sofern keine Aufbewahrungspflichten bestehen</Li>
            <Li><strong>Einschränkung der Verarbeitung</strong> (Art. 18 DSGVO)</Li>
            <Li><strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO): Export Ihrer Daten als maschinenlesbares Format</Li>
            <Li><strong>Widerspruch</strong> (Art. 21 DSGVO): Widerspruch gegen die Verarbeitung auf Basis berechtigter Interessen</Li>
            <Li><strong>Widerruf</strong> einer erteilten Einwilligung jederzeit mit Wirkung für die Zukunft</Li>
          </ul>
          <P style={{ marginTop: '16px' }}>
            Zur Ausübung Ihrer Rechte wenden Sie sich bitte an:{' '}
            <a href="mailto:info@immohq.eu" style={{ color: BLUE, fontWeight: 600 }}>info@immohq.eu</a>
          </P>
        </Section>

        <Section title="Beschwerderecht bei der Aufsichtsbehörde">
          <P>
            Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren. Die zuständige Aufsichtsbehörde für Niedersachsen ist:
          </P>
          <P>
            <strong>Die Landesbeauftragte für den Datenschutz Niedersachsen</strong><br />
            Prinzenstraße 5, 30159 Hannover<br />
            Tel.: 0511 120-4500<br />
            E-Mail: poststelle@lfd.niedersachsen.de
          </P>
        </Section>

        <Section title="Datensicherheit">
          <P>
            Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten gegen zufällige oder vorsätzliche Manipulationen, Verlust, Zerstörung oder gegen den Zugriff unberechtigter Personen zu schützen. Dazu gehören SSL/TLS-Verschlüsselung aller Datenübertragungen, Zugangskontrollen sowie regelmäßige Sicherheitsprüfungen.
          </P>
        </Section>

        <Section title="Drittanbieter und Auftragsverarbeiter">
          <P>Wir setzen folgende Dienstleister ein, mit denen Auftragsverarbeitungsverträge bestehen:</P>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <Li><strong>Supabase Inc.</strong> – Datenbankinfrastruktur und Authentifizierung (EU-Server)</Li>
            <Li><strong>Vercel Inc.</strong> – Hosting der Web-Applikation (EU-Infrastruktur verfügbar)</Li>
          </ul>
          <P>Eine Weitergabe an weitere Dritte findet nicht statt.</P>
        </Section>

        <Section title="Änderungen dieser Datenschutzerklärung">
          <P>
            Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn sich rechtliche Rahmenbedingungen oder unsere Datenverarbeitungspraktiken ändern. Die jeweils aktuelle Version ist unter{' '}
            <Link to="/datenschutz" style={{ color: BLUE }}>immohq.de/datenschutz</Link>{' '}
            abrufbar. Bei wesentlichen Änderungen informieren wir registrierte Nutzer per E-Mail.
          </P>
        </Section>

        <div style={{ marginTop: '48px', paddingTop: '32px', borderTop: `1px solid ${BORDER}` }}>
          <Link to="/" style={{ fontSize: '12px', fontWeight: 700, color: MUTED, letterSpacing: '0.5px' }}>
            ← Zurück zur Startseite
          </Link>
        </div>
      </div>

      <footer>
        <span>© 2025 IMMOHQ · Canel Sözer · Braunschweig</span>
        <div style={{ display: 'flex', gap: '24px' }}>
          <Link to="/impressum" style={{ color: 'rgba(255,255,255,0.2)' }}>Impressum</Link>
          <Link to="/datenschutz" style={{ color: 'rgba(255,255,255,0.4)' }}>Datenschutz</Link>
        </div>
      </footer>
    </div>
  );
}
